import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getRatingCombo from '../../services/dossier/get/getRatingCombo'
import getRatingComboByOrganizedUnit from '../../services/dossier/get/getRatingComboByOrganizedUnit'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess, fetchRatingComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchRatingCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const ratingCombo = yield call(getRatingCombo, auth.token)
    yield put(fetchRatingComboSuccess(ratingCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchRatingCombo () {
  yield takeLatest(combosActionTypes.FETCH_RATING_COMBO, fetchRatingCombo)
}

export function * fetchRatingComboByOrganizedUnit ({ organizedUnitId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const ratingComboByOrganizedUnit = yield call(getRatingComboByOrganizedUnit, auth.token, organizedUnitId)
    yield put(fetchCombosSuccess({ ratingComboByOrganizedUnit }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchRatingComboByOrganizedUnit () {
  yield takeLatest(combosActionTypes.FETCH_RATING_COMBO_BY_UO, fetchRatingComboByOrganizedUnit)
}
